function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlanetwin365({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 183.13 46.86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Livello_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m83.68,2.73c-.81,4.02-4.04,7.16-8.12,7.87-.19.03-.2.31,0,.35,4.05.8,7.23,4.01,7.95,8.04.03.19.31.19.35,0,.81-4.02,4.05-7.16,8.12-7.87.19-.03.2-.31,0-.35-4.06-.8-7.23-4.01-7.95-8.04-.03-.19-.31-.19-.35,0",
    style: {
      fill: "#3a3e45",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m94.25,14.95c-.53,2.64-2.66,4.7-5.33,5.17-.13.02-.13.2,0,.23,2.66.53,4.74,2.63,5.22,5.28.02.13.2.13.23,0,.53-2.64,2.66-4.7,5.33-5.17.13-.02.13-.2,0-.23-2.66-.53-4.74-2.63-5.22-5.28-.02-.13-.2-.13-.23,0",
    style: {
      fill: "#3a3e45",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m94.52.06c-.34,1.7-1.71,3.03-3.43,3.33-.08.01-.08.13,0,.15,1.72.34,3.06,1.69,3.36,3.4.01.08.13.08.15,0,.34-1.7,1.71-3.03,3.43-3.33.08-.01.08-.13,0-.14-1.71-.34-3.06-1.69-3.36-3.4-.01-.08-.13-.08-.15,0",
    style: {
      fill: "#3a3e45",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.73,26.92c1.28-2.48,2.96-4.76,4.95-6.73,2.49-2.45,5.47-4.42,8.72-5.74,3.24-1.32,6.75-2,10.26-2,3.51.01,7.01.71,10.24,2.05,3.23,1.33,6.19,3.31,8.66,5.76,1.96,1.95,3.6,4.21,4.86,6.66h4.6c-1.62-3.53-3.98-6.68-6.79-9.3-2.92-2.7-6.43-4.7-10.12-6.01-3.71-1.28-7.64-1.76-11.45-1.53-7.65.49-14.8,4.04-19.69,9.4-2.07,2.2-3.72,4.74-4.96,7.44h.72Z",
    style: {
      fill: "#3a3e45",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m68.6,46.86c-.91,0-1.26-.45-1.74-1.19l-5.85-8.52c-.46-.61-.96-1.55-1.25-2.31h-.05c.11.81.16,1.59.16,2.31v9.55c0,.09-.07.16-.16.16h-3.8c-.09,0-.16-.07-.16-.16v-14.9c0-.99.57-1.53,1.61-1.53h2.72c.97,0,1.34.55,1.77,1.19l5.64,8.24c.45.64.96,1.51,1.42,2.4h.14c-.11-.88-.16-1.65-.16-2.42v-9.25c0-.09.07-.16.16-.16h3.78c.09,0,.16.07.16.16v14.9c0,1-.56,1.53-1.61,1.53h-2.77Z",
    style: {
      fill: "#3a3e45",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.69,37.58c2.53,0,3.18-.45,3.18-2.17s-.65-2.17-3.18-2.17l-3.44.02v4.32h3.44ZM.16,46.86c-.09,0-.16-.07-.16-.16v-16.27c0-.08.06-.15.15-.16,2.43-.21,4.1-.23,7.61-.23,5.68,0,7.41,1.25,7.41,5.36s-1.67,5.36-6.89,5.36c-1.38,0-2.77-.08-4.03-.23v6.16c0,.09-.07.16-.16.16H.16Z",
    style: {
      fill: "#3a3e45",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.47,46.86c-2.94,0-4.63-1.3-4.63-3.56v-12.94c0-.09.07-.16.16-.16h3.94c.09,0,.16.07.16.16v12.09c0,.46.19.94,1.57.94h7.23c.08,0,.15.06.16.15l.18,2.87c0,.08-.06.16-.14.17-2.75.27-5.74.27-8.63.27",
    style: {
      fill: "#3a3e45",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m45.65,39.7c-.39-.97-1.92-4.87-2.19-5.71h-.5c-.27.84-1.79,4.74-2.17,5.71h4.86Zm3,7.16c-.07,0-.12-.04-.15-.1l-1.55-3.87h-7.46l-1.55,3.87c-.03.06-.08.1-.15.1h-4.05c-.05,0-.1-.02-.13-.07-.03-.04-.04-.1-.01-.15l6.15-15.26c.23-.67.82-1.1,1.55-1.1h3.85c.74,0,1.35.44,1.56,1.12l6.15,15.25s.02.1-.02.15c-.03.04-.08.07-.13.07h-4.05Z",
    style: {
      fill: "#3a3e45",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m81.81,46.86c-2.7,0-4.47-1.34-4.49-3.42v-9.88c.02-2.08,1.79-3.42,4.49-3.42,3.09,0,6.6,0,9.41.25.08,0,.15.08.14.17l-.18,2.78c0,.08-.08.15-.16.15h-8.02c-1.22,0-1.38.46-1.38.92v2.29h8.27c.09,0,.16.07.16.16v2.72c0,.09-.07.16-.16.16h-8.27v2.86c0,.46.17.94,1.38.94h8.02c.08,0,.15.07.16.15l.18,2.76c0,.08-.06.16-.14.17-2.82.25-6.32.25-9.41.25",
    style: {
      fill: "#3a3e45",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m100.51,46.86c-.09,0-.16-.07-.16-.16v-13.08h-6.15c-.09,0-.16-.07-.16-.16v-3.04c0-.09.07-.16.16-.16h16.59c.09,0,.16.07.16.16v3.04c0,.09-.07.16-.16.16h-6.15v13.08c0,.09-.07.16-.16.16h-3.96Z",
    style: {
      fill: "#3a3e45",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m131.45,46.86c-.84,0-1.48-.47-1.61-1.18l-2.55-10.44c-.13-.56-.24-1.18-.35-1.94h-.33c-.02.14-.05.28-.07.42-.08.51-.16,1.03-.28,1.54l-2.53,10.43c-.12.67-.81,1.17-1.63,1.17h-3.92c-.81,0-1.46-.49-1.59-1.18l-3.57-15.21s0-.1.03-.13c.03-.04.08-.06.12-.06h4.05c.08,0,.14.05.15.12l2.42,11.15c.12.63.19,1.28.27,2.04l.02.21h.37c.03-.16.05-.32.08-.48.1-.61.2-1.24.36-1.8l2.51-9.97c.13-.76.76-1.28,1.58-1.28h3.55c.8,0,1.43.52,1.56,1.3l2.55,10c.13.53.22,1.09.32,1.64.03.2.07.4.1.59h.37c.09-.93.18-1.63.29-2.2l2.44-11.21c.02-.07.08-.12.16-.12h4.05s.09.02.12.06c.03.04.04.09.03.13l-3.59,15.22c-.15.7-.79,1.17-1.58,1.17h-3.92Z",
    style: {
      fill: "#3a3e45",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.07,
    y: 30.28,
    width: 4.26,
    height: 16.58,
    rx: 0.16,
    ry: 0.16,
    style: {
      fill: "#3a3e45",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m165.95,46.86c-.91,0-1.26-.45-1.74-1.19l-5.85-8.52c-.46-.61-.96-1.55-1.25-2.31h-.05c.11.81.16,1.59.16,2.31v9.55c0,.09-.07.16-.16.16h-3.8c-.09,0-.16-.07-.16-.16v-14.9c0-.99.57-1.53,1.61-1.53h2.72c.97,0,1.34.55,1.77,1.19l5.64,8.24c.45.64.96,1.51,1.42,2.4h.14c-.11-.88-.16-1.65-.16-2.42v-9.25c0-.09.07-.16.16-.16h3.78c.09,0,.16.07.16.16v14.9c0,1-.56,1.53-1.61,1.53h-2.77Z",
    style: {
      fill: "#3a3e45",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m176.42,41.9c1.15,0,1.93.2,2.1,1.06h.05c.18-.94.87-1.23,2.09-1.24,1.74-.01,2.47.63,2.47,2.4,0,.81-.09,1.66-.22,2.42l-1.38-.06c.06-.85.08-1.28.08-1.85,0-.85-.24-1.1-1.21-1.1-.77,0-1.16.15-1.15.87v1.27h-1.26v-1.27c0-.73-.46-.8-1.11-.79-.81,0-.92.19-.92.87s.02,1.36.05,1.85l-1.33.07c-.15-.77-.22-1.52-.22-2.25,0-1.65.46-2.26,1.93-2.26",
    style: {
      fill: "#3a3e45",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m180.16,37.5c-1.03,0-1.34.16-1.34.8,0,.31.08.53.34.85,2.1,0,2.55-.08,2.55-.87,0-.73-.48-.78-1.55-.78m-.04-1.71c1.93,0,2.99.46,2.99,2.51s-.88,2.6-4.23,2.6c-3.8,0-4.4-.97-4.4-2.92,0-.36,0-1.04.22-1.73l1.2.08c-.02.54-.02.86-.02,1.65,0,.89.3,1.11,2.08,1.16-.38-.37-.5-.78-.5-1.38,0-1.53.75-1.97,2.65-1.97",
    style: {
      fill: "#3a3e45",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m176.07,33.37l1.51.07.15-1.12c.22-1.56,1.21-1.95,2.7-1.95s2.69.54,2.69,2.43c0,.67-.1,1.53-.27,2.38l-1.43-.15c.08-.65.15-1.27.15-1.75,0-.88-.36-1.08-1.18-1.11-1.06-.04-1.16.3-1.29,1.2l-.12,1.04c-.04.32-.31.54-.68.53l-3.66-.18v-4.19l1.43.06v2.75Z",
    style: {
      fill: "#3a3e45",
      strokeWidth: 0
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanetwin365);
export default __webpack_public_path__ + "static/media/planetwin365.e9122687ee8b9ebbe522e8d42c543b7c.svg";
export { ForwardRef as ReactComponent };